import { Icons } from "components/Icons";

interface Menu {
  id: number;
  name: string;
  path?: string;
  icon: JSX.Element;
  items?: Menu[];
  roles: string[];
}

export const menus: Menu[] = [
  {
    id: 1,
    name: "Dashboard",
    path: "/dashboard",
    icon: <Icons.Dashboard fontSize="large" />,
    roles: ["0"],
  },
  {
    id: 2,
    name: "Encomendas",
    path: "/encomendas",
    icon: <Icons.Order style={{ fontSize: "24px" }} />,
    roles: ["0"],
  },
  {
    id: 3,
    name: "Destinatários",
    path: "/destinatarios",
    icon: <Icons.User style={{ fontSize: "24px" }} />,
    roles: ["0"],
  },
  {
    id: 4,
    name: "Logs Correios",
    path: "/correios",
    icon: <Icons.ListAltIcon style={{ fontSize: "24px" }} />,
    roles: ["1"],
  },
];